export default require("./lib/Rubberhose-Lottie.vue").default;
